import { parseHhmm } from './reportTime';

export const NO_TICKET_KEY = '';

const pad = n => String(n).padStart(2, '0');
const isoDate = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** The calendar month around `today`. Read from local fields: `toISOString` is UTC and moved
 *  both ends a day east of UTC. */
export function monthRange(today = new Date()) {
    const y = today.getFullYear();
    const m = today.getMonth();
    return { startDate: isoDate(new Date(y, m, 1)), endDate: isoDate(new Date(y, m + 1, 0)) };
}

/** Minutes as decimal hours, the quantity an invoice position takes: 765 → "12,75 h". */
export function formatHours(minutes) {
    const hours = (Number(minutes) || 0) / 60;
    return `${hours.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} h`;
}

const byName = (a, b) => a.localeCompare(b, 'de', { sensitivity: 'base' });

/** Totals per ticket and per person over a raw `POST /Project/projectStats` response. */
export function summarisePeriod(stats) {
    const tickets = new Map();
    const users = [];
    const personDays = new Set();
    const onSiteDays = new Set();
    let minutes = 0;
    let travelMinutes = 0;

    for (const user of stats || []) {
        const days = new Set();
        const userOnSite = new Set();
        let userMinutes = 0;
        let userTravel = 0;

        for (const entry of user.entries || []) {
            const booked = parseHhmm(entry.work_time) ?? 0;
            const travel = Number(entry.travel_minutes) || 0;
            userMinutes += booked;
            userTravel += travel;
            days.add(entry.date);
            personDays.add(`${user.user_id}|${entry.date}`);
            if (entry.location === 'On-Site') {
                userOnSite.add(entry.date);
                onSiteDays.add(`${user.user_id}|${entry.date}`);
            }

            // The title is the fallback for a backend that does not send the id yet.
            const key = entry.ticket_id || (entry.ticket_title ? `title:${entry.ticket_title}` : NO_TICKET_KEY);
            const ticket = tickets.get(key) || { key, title: entry.ticket_title || '', minutes: 0 };
            ticket.minutes += booked;
            tickets.set(key, ticket);
        }

        users.push({
            userId: user.user_id,
            name: user.name || user.username || 'Unbekannt',
            minutes: userMinutes,
            travelMinutes: userTravel,
            days: days.size,
            onSiteDays: userOnSite.size,
        });
        minutes += userMinutes;
        travelMinutes += userTravel;
    }

    const ticketRows = [...tickets.values()].sort((a, b) => {
        if ((a.key === NO_TICKET_KEY) !== (b.key === NO_TICKET_KEY)) return a.key === NO_TICKET_KEY ? 1 : -1;
        return byName(a.title, b.title);
    });

    return {
        minutes,
        travelMinutes,
        personDays: personDays.size,
        onSiteDays: onSiteDays.size,
        tickets: ticketRows,
        users: users.sort((a, b) => byName(a.name, b.name)),
    };
}
